


































































































































import mobileTypeMixin from '@/global/mobile/mobileTypeMixin'
import ROUTE from '@/router/routeEnum'
import mixins from 'vue-typed-mixins'
import globalMixin from '../globalMixin'
import formulaireMixin from './formulaireMixin'
import { FormulaireInputOutput, FormulaireOutput } from './models/formulaire'

export default mixins(formulaireMixin, mobileTypeMixin, globalMixin).extend({
    data() {
        return {
            headers: this.isMobileDevice()
                ? [
                      { text: 'Nom', value: 'nom' },
                      { text: 'Réponses', value: 'demandes' },
                      { text: '', value: 'actions', align: 'end', sortable: false },
                  ]
                : [
                      { text: 'Nom', value: 'nom' },
                      { text: 'Date de création', value: 'dateCreation' },
                      { text: 'Réponses', value: 'demandes' },
                      { text: '', value: 'actions', align: 'end', sortable: false },
                  ],
            afficherSupprimes: false,
            page: 1,
            pageCount: 0,
            simulation: false,
        }
    },
    computed: {
        isMobileAndEdit(): string {
            if (this.isMobileDevice()) {
                if (!this.formulaireEdite) return 'Formulaires'
                if (this.formulaireEdite) return 'Ajout Formulaire'
            } else {
                if (!this.formulaireEdite) return 'Gestion des Formulaires'
                if (this.formulaireEdite) return "Ajout d'un Formulaire"
            }
            return 'Formulaires'
        },
        formulairesFiltres(): Array<FormulaireOutput> {
            return this.formulaires.filter((form) => (this.afficherSupprimes ? true : !form.supprime))
        },
    },
    methods: {
        simulate() {
            this.simulation = true
        },
        cancelSimulation() {
            this.simulation = false
        },
        ajouterFormulaire() {
            this.formulaireEdite = new FormulaireOutput()
        },
        ajouterUnChamp() {
            this.formulaireEdite?.inputs.push(new FormulaireInputOutput())
        },
        supprimerChamp(index: number) {
            this.formulaireEdite?.inputs.splice(index, 1)
        },
        editFormulaire(form: FormulaireOutput) {
            this.formulaireEdite = form
        },
        navigateToReponses(idModele: number) {
            this.navigateTo(ROUTE.FORMULAIRE_REPONSES_ADMIN, { idModele: idModele.toString() })
        },
        questionUp(input: FormulaireInputOutput, index: number) {
            if (!this.formulaireEdite) return
            input.ordre = index - 1
            this.formulaireEdite.inputs.splice(index, 1)
            this.formulaireEdite.inputs[index - 1].ordre = index
            this.formulaireEdite.inputs.splice(index - 1, 0, input)
        },
        questionDown(input: FormulaireInputOutput, index: number) {
            if (!this.formulaireEdite) return
            input.ordre = index + 1
            this.formulaireEdite.inputs.splice(index, 1)
            this.formulaireEdite.inputs[index].ordre = index
            this.formulaireEdite.inputs.splice(index + 1, 0, input)
        },
        rulesQuestion(question: FormulaireInputOutput) {
            return question.facultatif ? [] : [this.isFilled]
        },
        labelQuestion(question: FormulaireInputOutput) {
            return `${question.titre}${question.facultatif ? '' : ' *'}`
        },
    },
})
